import React, { useEffect, useRef, useState } from "react";

import { MeetingTakeawayTextArea } from "./MeetingTakeawayTextArea";
import { MeetingTopicTextArea } from "./MeetingTopicTextArea";
import {
  WbEventHandlerMixins,
  quickAddEventHandler,
  removeEmojiContent,
  getUserId,
  getWsTagId,
  sanitize,
} from "../../utils/common";
import { resetTextAreaHeight } from "./commonTags";
import { nowToUnix } from "../../apps/meetings/utils/dates";

export const TopicTakeawayTextarea = (props) => {
  const [topicTag, setTopicTag] = useState(props.emptyGlobalTag);
  const [takeTag, setTakeTag] = useState(0);
  const [topicDoneBtn, setTopicDoneBtn] = useState(false);
  const [takeDoneBtn, setTakeDoneBtn] = useState(false);
  const submitByDoneBtn = useRef(false);
  const containerRef = useRef(null);
  const meetingTopicRef = useRef(null);
  const meetingTakeRef = useRef(null);

  const { meeting_topics, noTopicNotedata, meeting, currentUser, takeTopicId } = props;
  const isFirefox = typeof InstallTrigger !== "undefined";
  const intMinHeight =
    typeof meeting_topics !== "undefined" && meeting_topics.length > 0
      ? "44px"
      : "700px";
  const heightA = isFirefox && noTopicNotedata ? "700px" : "44px";


  const removeTopicCkEditor = () => {
    const eleId = `meeting_topic_${props.meeting.id}`;
    if (eleId) {
      let insta = CKEDITOR.instances[eleId];
      if (insta) {
        // TODO: Another magic global function
        destroyMeetingEditor(eleId);
      }
    }
  }

  const cleanUpAddingATopic = () => {
    setTopicTag(props.emptyGlobalTag);
    setTopicDoneBtn(false);
    if (meetingTopicRef?.current) {
      $.trim($(meetingTopicRef.current).html(""));
    }
    props.clearGlobalValueBta();
    removeTopicCkEditor();
  }

  const closeTextArea = eleId => {
    resetTextAreaHeight({ eleId: `#${eleId}` });

    $(meetingTakeRef.current).val("");
    if ($(`#${eleId}`).parents(".meeting_take_sortable").length) {
      $(`#${eleId}`)
        .parents(".meeting_take_sortable")
        .removeClass("bgwhite");
    }
  }

  const afterSaveTake = (takeId, takeDesc) => {
    setTakeTag(0);
    setTakeDoneBtn(false);

    const eleId = `meeting_take_${meeting.id}`;
    destroyMeetingEditor(eleId);
    closeTextArea(eleId);
  }

  const submitTake = (takeText, tag) => {
    const sanitizedTakeText = sanitize(takeText);
    const meetingId = meeting.id;
    const fieldObj = $(meetingTakeRef.current);
    const meetingWsId = meeting.ws_id;
    const quickAddAIParams = {};

    let quickAddAI = !(!sanitizedTakeText.match(/#(.*)#/) && !sanitizedTakeText.match(/@(.*)@/) && !sanitizedTakeText.match(/(\!)(\d)+(\?)*/g));
    if (quickAddAI && sanitizedTakeText.match(/@(.*)@/) && !sanitizedTakeText.match('data-userid')) {
      quickAddAI = false;
    }
    if (quickAddAI && sanitizedTakeText.match(/#(.*)#/) && !sanitizedTakeText.match('data-quickaddtagid')) {
      quickAddAI = false;
    }

    const takeTextNoEmoji = removeEmojiContent(sanitizedTakeText);
    if (takeTextNoEmoji == '' || takeTextNoEmoji == null || typeof takeTextNoEmoji === 'undefined') {
      return null;
    }

    if (quickAddAI == true) {
      const isvalid = quickAddEventHandler(fieldObj);
      if (!isvalid) {
        return null;
      }
      quickAddAIParams.tagId = takeTextNoEmoji.match(/#(.*)#/)
        ? getWsTagId(takeTextNoEmoji)
        : "";
      if (
        quickAddAIParams.tagId == "" ||
        typeof quickAddAIParams.tagId === "undefined"
      ) {
        quickAddAIParams.tagId = meetingWsId;
      }
      quickAddAIParams.userId = takeTextNoEmoji.match(/@(.*)@/)
        ? getUserId(takeTextNoEmoji)
        : "";
    }
    if (takeTopicId != "") {
      const filesTopicObj = $(`#meeting_topic_${meetingId}`);
      $.trim($(filesTopicObj).html(""));
      resetTextAreaHeight({ eleId: `#meeting_topic_${meetingId}` });
    }

    props.clearGlobalValueBta();

    $.trim($(fieldObj).html(""));
    return { takeText: takeTextNoEmoji, tag, takeTopicId, quickAddAI, quickAddAIParams }
  }

  const saveTakeText = (event) => {
    const empTakeContainer = $(`#meeting_take_${meeting.id}`);
    const agendaSearchContainer = $(".agenda-autosearch");
    const tagListContainer = $(".meeting-tag-wrapper");
    let takeText = "";
    let highlightedText = ""; // adding a more reliable way to track click vs drag (mousedown/mouseup)

    let ckEditorFlag = !$(empTakeContainer).is(event.target) &&
      $(empTakeContainer).has(event.target).length === 0;
    let takeawayCKEditorInput = $(`#cke_meeting_take_${meeting.id}`);

    if (takeawayCKEditorInput != undefined) {
      let takeawayCKEditorInputValue = $(`#cke_meeting_take_${meeting.id}` + ' iframe').contents().find('body').html();
      if ($(takeawayCKEditorInputValue).text() == '') {
        takeawayCKEditorInputValue = '';
      }
      empTakeContainer.val(takeawayCKEditorInputValue);
      ckEditorFlag = !$(takeawayCKEditorInput).is(event.target) &&
        $(takeawayCKEditorInput).has(event.target).length === 0;
    }

    if (window.getSelection) {
      highlightedText = window.getSelection().toString();
    } else if (document.selection && document.selection.type != "Control") {
      highlightedText = document.selection.createRange().text;
    }

    if (highlightedText != "") {
      return null;
    } else {
      if (
        ckEditorFlag &&
        !$(agendaSearchContainer).is(event.target) && 
        $(agendaSearchContainer).has(event.target).length === 0 &&
        !$(tagListContainer).is(event.target)
      ) {
        const eleId = `meeting_take_${meeting.id}`;
        let mainText = "";

        takeText = $.trim($('#' + eleId).val());

        if (eleId) {
          let insta = CKEDITOR.instances[eleId];
          if (insta) {
            mainText = removeEmojiContent(CKEDITOR.instances[eleId].getData().trim());
          }
        }
        if (
          mainText
            .trim().length == 0 || $('#cke_' + eleId + ' iframe').contents().find('body').text() == ''
        ) {
          return null;
        }
        const tag = meetingTakeRef.current?.getAttribute("data-tag");
        return submitTake(takeText, tag);
      } else if (empTakeContainer.parents(".meeting_take_sortable").length) {
        empTakeContainer
          .parents(".meeting_take_sortable")
          .removeClass("bgwhite");
        if (typeof eleId != 'undefined' && eleId) {
          return null;
        }

      }
    }
  }

  // This is was originally addAiTopic
  const submitTopic = (event, userAction = false, flag) => {
    const meetingId = props.meeting.id;
    const meetingWsId = props.meeting.ws_id;
    const fieldObj = $(meetingTopicRef.current);
    const eleId = `meeting_topic_${meeting.id}`;
    const takeawayCKEditorInput = $('#cke_' + eleId);
    let takeawayCKEditorInputValue = '';

    if (takeawayCKEditorInput != undefined) {
      takeawayCKEditorInputValue = $('#cke_' + eleId + ' iframe').contents().find('body').html();
      if ($(takeawayCKEditorInputValue).text() == '') {
        takeawayCKEditorInputValue = '';
      }
      $('#' + eleId).val(takeawayCKEditorInputValue);
    }

    if (!$(takeawayCKEditorInputValue).text().replace(/\s/g, '').length) {
      takeawayCKEditorInputValue = '';
    }

    if (
      takeawayCKEditorInputValue == '' ||
      takeawayCKEditorInputValue == null ||
      typeof takeawayCKEditorInputValue === 'undefined' ||
      $(takeawayCKEditorInputValue).text() == '' ||
      takeawayCKEditorInputValue.length == 0
    ) {
      fieldObj.innerHTML = '';
      return null;
    }

    let quickAddAI = !(!takeawayCKEditorInputValue.match(/#(.*)#/) && !takeawayCKEditorInputValue.match(/@(.*)@/) && !takeawayCKEditorInputValue.match(/(\!)(\d)+(\?)*/g));
    if (quickAddAI && takeawayCKEditorInputValue.match(/@(.*)@/) && !takeawayCKEditorInputValue.match('data-userid')) {
      quickAddAI = false;
    }
    if (quickAddAI && takeawayCKEditorInputValue.match(/#(.*)#/) && !takeawayCKEditorInputValue.match('data-quickaddtagid')) {
      quickAddAI = false;
    }
    if (takeawayCKEditorInputValue.length == 0) {
      return null;
    }

    if (!topicDoneBtn) {
      setTopicDoneBtn(true)
    }

    // Notify typing event
    // TODO: More global functions
    if (!getMeetingTyping()) {
      typing("meet");
      setMeetingTyping(true);
    } else {
      let timeoutId = null;
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        typingTimeOut("meet");
      }, 3500);
    }

    // if user is typing and both the users are active in meeting, then display the warning
    if ($("#typing-alert").css("display") == "none") {
      // element is hidden
      $(".topic-alert")
        .delay(100)
        .fadeOut();
    } else {
      $(".topic-alert")
        .delay(500)
        .fadeIn();
    }

    if (event && event.ctrlKey && event.keyCode == 13) {
      if (navigator.userAgent.indexOf("Mac OS X") != -1) {
        if (navigator.userAgent.indexOf("Chrome") != -1) {
          $.trim($(fieldObj).html(`${takeawayCKEditorInputValue}<br /><br />`));
          WbEventHandlerMixins.placeCaretAtEnd($(fieldObj).get(0));
        } else {
          $.trim($(fieldObj).html(takeawayCKEditorInputValue));
          WbEventHandlerMixins.placeCaretAtEnd($(fieldObj).get(0));
        }
      } else if (navigator.userAgent.indexOf("Chrome") != -1) {
        $.trim($(fieldObj).html(`${takeawayCKEditorInputValue}<br /><br />`));
        WbEventHandlerMixins.placeCaretAtEnd($(fieldObj).get(0));
      } else {
        $.trim($(fieldObj).html(takeawayCKEditorInputValue));
        WbEventHandlerMixins.placeCaretAtEnd($(fieldObj).get(0));
      }
      return null;
    } else if (
      // submit if user presses enter key / ctrl key/command key + 's' key / enter key is pressed when in quick AI mode
      (event.keyCode == 13 && quickAddAI == true) ||
      userAction == true ||
      ((event.ctrlKey || event.metaKey) && event.keyCode == 83) ||
      event.keyCode == 9
    ) {
      const tag = $(".meeting-tag-options").attr("data-tag");

      const quickAddAIParams = {};
      if (quickAddAI == true) {
        const isvalid = quickAddEventHandler(fieldObj);
        if (!isvalid) {
          return null;
        }
        quickAddAIParams.tagId = getWsTagId(takeawayCKEditorInputValue);
        if (
          quickAddAIParams.tagId == "" ||
          typeof quickAddAIParams.tagId === "undefined"
        ) {
          quickAddAIParams.tagId = meetingWsId;
        }
        quickAddAIParams.userId = getUserId(takeawayCKEditorInputValue);
      }
      let topicToTake = false;
      if (event.keyCode == 9 || flag) {
        topicToTake = true;
      } else {
        $.trim($(fieldObj).html(""));
        resetTextAreaHeight({ eleId: `#meeting_topic_${meetingId}` });
      }
      if (props.disabledDoneBtn === 0 || (props.disabledDoneBtn === 1 && flag)) {
        return { topicText: takeawayCKEditorInputValue, tag, quickAddAI, quickAddAIParams };
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  const saveTopicText = (event, flag = false) => {
    const empTopicContainer = $(`#meeting_topic_${meeting.id}`);
    const agendaSearchContainer = $(".agenda-autosearch");
    const tagListContainer = $(".meeting-tag-wrapper");
    if (
      !$(empTopicContainer).is(event.target) &&
      $(empTopicContainer).has(event.target).length === 0 &&
      !$(agendaSearchContainer).is(event.target) &&
      $(agendaSearchContainer).has(event.target).length === 0 &&
      !$(tagListContainer).is(event.target)
    ) {
      return submitTopic(event, true, flag);
    } else if (
      $(agendaSearchContainer).is(event.target) ||
      $(agendaSearchContainer).has(event.target).length > 0
    ) {
      setTimeout(() => {
        // TODO: Example of JQuery. Future refactor
        WbEventHandlerMixins.placeCaretAtEnd(
          $(`#meeting_topic_${meeting.id}`).get(0)
        );
      }, 10);
      return null;
    }
  };

  const handleTakeKeyDown = (event) => {
    const fieldObj = $(meetingTakeRef.current);
    const takeText = $.trim($(fieldObj).html());
    if (
      $(fieldObj)
        .text()
        .trim().length == 0
    ) {
      return;
    }
    const quickAddAI = $(fieldObj).data("quickAddAI");
    if (
      ((event.keyCode == 13 && quickAddAI == true) ||
        ((event.ctrlKey || event.metaKey) && event.keyCode == 83)) &&
      takeText != ""
    ) {
      const tag = $(event.target)
        .closest(".meeting-take-sec")
        .find(".meeting-tag-options")
        .attr("data-tag");
      event.preventDefault();
      return submitTake(takeText, tag);
    }
  }

  const handleSubmit = (event = null, flag = false) => {
    const topicData = saveTopicText(event, flag);
    const takeData = saveTakeText(event);
    const { firstname, lastname } = currentUser;
    const requestPayload = {
      descTopic: '',
      descTakeaway: '',
      meetingId: meeting.id,
      tagTopic: 0,
      tagTake: 0,
      pos: nowToUnix(),
      firstName: firstname,
      lastName: lastname,
      topicQuickAddAI: false,
      topicQuickAddAIParams: {},
      takeQuickAddAI: false,
      takeQuickAddAIParams: {},
      takeCB: afterSaveTake
    };

    if (topicData) {
      const sanitizedTopicText = sanitize(topicData.topicText || '');
      requestPayload.descTopic = sanitizedTopicText;
      requestPayload.tagTopic = topicData?.quickAddAI ? 1 : (topicData?.tag || '');
      requestPayload.topicQuickAddAI = topicData?.quickAddAI || false;
      requestPayload.topicQuickAddAIParams = topicData?.quickAddAI ? topicData?.quickAddAIParams : {};
    }

    if (takeData) {
      const sanitizedTakeText = sanitize(takeData.takeText || '');
      requestPayload.descTakeaway = sanitizedTakeText;
      requestPayload.tagTake = takeData?.quickAddAI ? 1 : (takeData?.tag || '');
      requestPayload.takeQuickAddAI = takeData?.quickAddAI || false;
      requestPayload.takeQuickAddAIParams = takeData?.quickAddAI ? takeData?.quickAddAIParams : {};
    }

    if (requestPayload.descTopic || requestPayload.descTakeaway) {
      props.saveInitMeetingTopicTakeaway(requestPayload);
    };

    submitByDoneBtn.current = true;
    // Close Editors
    cleanUpAddingATopic();
    afterSaveTake();
  }

  const handleClickOutSide = (event) => {
    const isClickOutsideContainer = containerRef.current && !containerRef.current.contains(event.target)
    const hasTopicEditorData = $(`#cke_meeting_topic_${meeting.id}` + ' iframe').contents().find('body').html();
    const hasTakeEditorData = $(`#cke_meeting_take_${meeting.id}` + ' iframe').contents().find('body').html();
    const topicText = $(hasTopicEditorData).text();
    const takeText = $(hasTakeEditorData).text();
    // TODO: I don't like this approach, but unfortunately this element can't be ref, and they don't have ids 
    const mentionElement = event.target.closest('ul.mention-suggestions') || event.target.closest('li.mention-suggestions-li') || event.target.closest('li.mention-meeting-sugg-li') || event.target.closest('div.mtagoption');
    const ckEditorDialog = document.getElementsByClassName('cke_dialog_container')[0]?.contains(event.target);
    const ckEditorDialogSecondary = document.getElementsByClassName('cke_dialog_container')[1]?.contains(event.target);
    const isCkEditorOpen = ckEditorDialog || ckEditorDialogSecondary;

    // Editor is Open
    if (isClickOutsideContainer && isCkEditorOpen) return;

    // Auto-submit
    if (isClickOutsideContainer && !!(topicText || takeText) && !submitByDoneBtn.current && !mentionElement) {
      handleSubmit(event)
    }

    // close Topic if empty
    if (!topicText && isClickOutsideContainer && !mentionElement) {
      cleanUpAddingATopic();
    }
    // close Take if empty
    if (!takeText && isClickOutsideContainer && !mentionElement) {
      afterSaveTake();
    }

    submitByDoneBtn.current = false
  };

  const handleCloseWindow = (event) => {
    const topic = `meeting_topic_${meeting.id}`;
    const take = `meeting_take_${meeting.id}`;
    const topicCKEditorInputValue = $(`#cke_${topic} iframe`).contents().find('body').html()
    const topicText = $(topicCKEditorInputValue).text().trim();
    const takeawayCKEditorInputValue = $(`#cke_${take} iframe`).contents().find('body').html()
    const takeText = $(takeawayCKEditorInputValue).text().trim()

    if (topicText.length > 0 || takeText.length > 0) {
      event.preventDefault();
      event.returnValue = '';
    }
  }

  useEffect(() => {
    if (containerRef.current) {
      document.addEventListener('click', handleClickOutSide);
      window.addEventListener('beforeunload', handleCloseWindow)
    }

    return () => {
      document.removeEventListener('click', handleClickOutSide);
      window.removeEventListener('beforeunload', handleCloseWindow)
    }
  }, []);

  return (
    <div
      ref={containerRef}
      className="textSecMain textareaEmptySec displayTable"
      style={{
        width: "100%",
        borderBottom: "1px solid #ECEFF1",
        minHeight: intMinHeight,
        height: heightA,
        tableLayout: "fixed"
      }}
    >
      <MeetingTopicTextArea
        meetingObj={props.meeting}
        userPermission={props.userPermission}
        onSubmit={handleSubmit}
        currentUser={props.currentUser}
        saveTags={props.saveTags}
        takeTopicId={props.takeTopicId}
        emptyGlobalTag={props.emptyGlobalTag}
        disabledDoneBtn={props.disabledDoneBtn}
        resetTopicTag={props.resetTopicTag}
        clearGlobalValueBta={props.clearGlobalValueBta}
        updateTopicTake={props.updateTopicTake}
        ref={meetingTopicRef}
        showDoneBtn={topicDoneBtn}
        onDoneBtn={bool => setTopicDoneBtn(bool)}
        tag={topicTag}
        onTopicTag={tag => setTopicTag(tag)}
      />
      <MeetingTakeawayTextArea
        meetingObj={props.meeting}
        userPermission={props.userPermission}
        onSubmit={handleSubmit}
        onSubmitTake={submitTake}
        onKeyDown={handleTakeKeyDown}
        currentUser={props.currentUser}
        saveTags={props.saveTags}
        actions={props.actions}
        clearGlobalValue={props.clearGlobalValue}
        takeTopicId={props.takeTopicId}
        clearGlobalValueBta={props.clearGlobalValueBta}
        ref={meetingTakeRef}
        tag={takeTag}
        onTakeTag={tag => setTakeTag(tag)}
        showDoneBtn={takeDoneBtn}
        onDoneBtn={bool => setTakeDoneBtn(bool)}
      />
    </div>
  );
}
